import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Alert, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { useUser } from "@clerk/clerk-react";

const FEEDBACK_URL = process.env.REACT_APP_FASTAPI_HOST ? `${process.env.REACT_APP_FASTAPI_HOST}/api/feedback` : 'http://localhost:8000/api/feedback';

// Get user id from Clerk
const getDeviceInfo = () => {
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    // Add more fields as needed
  };
};

export default function ContactPage({ t }) {
  //const { t, lang } = useTranslation();
  const { user } = useUser();
  // const userId = user?.id || null;

  const [category, setCategory] = useState('support');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [screenshotUrl, setScreenshotUrl] = useState('');
  const [feedbackResult, setFeedbackResult] = useState('');
  const [feedbackLoading, setFeedbackLoading] = useState(false);

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    setFeedbackLoading(true);
    setFeedbackResult('');
    try {
      const payload = {
        // user_id: userId, // Do not send user_id from frontend
        user_email: user?.emailAddresses?.[0]?.emailAddress || user?.username || undefined,
        category,
        title,
        content,
        screenshot_url: screenshotUrl || undefined,
        device_info: getDeviceInfo(),
      };
      const res = await fetch(FEEDBACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('Failed to submit feedback');
      setFeedbackResult('Feedback submitted. Thank you for your suggestion!');
      setTitle('');
      setContent('');
      setScreenshotUrl('');
      setCategory('support');
    } catch (err) {
      setFeedbackResult('Error: ' + err.message);
    } finally {
      setFeedbackLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 480, width: '100%', mx: 'auto', mt: 6, p: 3, boxShadow: 2, borderRadius: 2, bgcolor: '#fff', '@media (min-width:900px)': { maxWidth: 600 } }}>
      <Typography variant="h5" fontWeight={600} mb={2} align="center">
        {t['contact_title'] || 'Contact Us'}
      </Typography>
      <Typography variant="body1" mb={2} align="center">
        {t['contact_desc'] || 'If you encounter any issues or have suggestions, please leave a message below or email us at'}
        <a
          href="mailto:support@marstrix.com"
          style={{ color: '#3A6752', textDecoration: 'underline', fontWeight: 500, marginLeft: 4 }}
          target="_blank" rel="noopener noreferrer"
          onClick={e => { e.stopPropagation(); }}
        >
          {t['contact_email'] || 'support@marstrix.com'}
        </a>
      </Typography>
      <form onSubmit={handleFeedbackSubmit}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="category-label">{t['contact_category'] || 'Category'}</InputLabel>
          <Select
            id="contact-category"
            labelId="category-label"
            value={category}
            label={t['contact_category'] || 'Category'}
            onChange={e => setCategory(e.target.value)}
            required
          >
            <MenuItem value="support">{t['contact_category_support'] || 'Technical Support'}</MenuItem>
            <MenuItem value="suggestion">{t['contact_category_suggestion'] || 'Suggestion'}</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label={t['contact_title_label'] || 'Title (optional)'}
          fullWidth
          value={title}
          onChange={e => setTitle(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          label={t['contact_content_label'] || 'Describe your issue or suggestion'}
          multiline
          minRows={6}
          fullWidth
          value={content}
          onChange={e => setContent(e.target.value)}
          required
          sx={{ mb: 2, fontSize: 20, '.MuiInputBase-root': { fontSize: 20 }, '@media (min-width:900px)': { minHeight: 180 } }}
        />
        {/* <TextField
          label="Screenshot URL (optional)"
          fullWidth
          value={screenshotUrl}
          onChange={e => setScreenshotUrl(e.target.value)}
          sx={{ mb: 2 }}
        /> */}
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: '#222',
            color: '#fff',
            '&:hover': { backgroundColor: '#111' },
          }}
          disabled={feedbackLoading || !content}
          fullWidth
        >
          {feedbackLoading ? (t['contact_submitting'] || 'Submitting...') : (t['contact_submit'] || 'Submit Feedback')}
        </Button>
      </form>
      {feedbackResult && (
        <Alert severity={feedbackResult.startsWith('Error') ? 'error' : 'success'} sx={{ mt: 2 }}>
          {feedbackResult.startsWith('Error') ? (t['contact_error'] || 'Error: ') + feedbackResult.replace('Error: ', '') : t['contact_success'] || feedbackResult}
        </Alert>
      )}
    </Box>
  );
}
